import {InjectionToken} from '@angular/core';

import {LANG_EN_NAME, LANG_EN_TRANS} from '../../language/lang-en';
import {LANG_DE_NAME, LANG_DE_TRANS} from '../../language/lang-de';
import {LANG_FR_NAME, LANG_FR_TRANS} from '../../language/lang-fr';
import {LANG_IT_NAME, LANG_IT_TRANS} from '../../language/lang-it';

export const TRANSLATIONS = new InjectionToken('translations');

export const dictionary = {
  [LANG_EN_NAME]: LANG_EN_TRANS,
  [LANG_DE_NAME]: LANG_DE_TRANS,
  [LANG_FR_NAME]: LANG_FR_TRANS,
  [LANG_IT_NAME]: LANG_IT_TRANS
};

export const TRANSLATION_PROVIDERS = [
  {provide: TRANSLATIONS, useValue: dictionary},
];
